import styled from 'styled-components';

import FACEBOOK from '../../assets/imgs/icon/facebook.svg';
import INSTAGRAM from '../../assets/imgs/icon/instagram.svg';
import X_TWITTER from '../../assets/imgs/icon/x-twitter.svg';
import { Flex } from '../../GlobalComponents/Flex';
import { IconButton } from '../../GlobalComponents/IconButton';

type SocialLinkProps = {
	url: string;
	icon: string;
	alt: string;
};

const platforms: SocialLinkProps[] = [
	{
		url: 'https://www.facebook.com/BiggbyCoffee.Bhappy',
		icon: FACEBOOK,
		alt: 'Facebook'
	},
	{
		url: 'https://x.com/BIGGBYCOFFEE',
		icon: X_TWITTER,
		alt: 'Twitter'
	},
	{
		url: 'https://instagram.com/biggbycoffee',
		icon: INSTAGRAM,
		alt: 'Instagram'
	}
];

export const SocialLink: React.FC = () => (
	<Flex
		$flexDirection="row"
		$columnGap="20px"
		$margin="20px 0"
		$placeContent="center center"
		$alignItems="center"
	>
		{platforms.map(({ icon, url, alt }) => (
			<SocialMedia key={alt}>
				<IconButton
					url={icon}
					alt={alt}
					width={36}
					height={36}
					onClick={() => {
						window.open(url, '_blank', 'noopener noreferrer');
					}}
				></IconButton>
			</SocialMedia>
		))}
	</Flex>
);

const SocialMedia = styled.div`
	transition: transform 0.2s;
	&:hover {
		transform: scale(1.2);
	}
`;
